const baseUrl = {
  baseUrl: require('@config/projectConfig').url, // 测试
  imgBaseUrl: process.env.NODE_ENV === 'development' ? 'airworthiness_certified/' : 'https://eh-workflow.oss-cn-shenzhen.aliyuncs.com/'
}

export default baseUrl;
